module.exports = __webpack_public_path__ + "static/Tax_img1@2x.71fd5974.png";